import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("gmm_admin_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me").then((r) => setEmail(r.data.email))
      .catch(() => localStorage.removeItem("gmm_admin_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("gmm_admin_token", r.data.token);
    setEmail(r.data.email);
  };
  const logout = () => { localStorage.removeItem("gmm_admin_token"); setEmail(null); };

  return <AuthCtx.Provider value={{ email, loading, login, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
